import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'joinElementsFromArray',
})
export class JoinElementsFromArrayPipe implements PipeTransform {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  transform(arr: any[], props: string[], separator = ', '): string {
    return Array.isArray(arr) ? arr.map((item) => props.map((el) => `${item[el]}`).join(' ')).join(separator) : '';
  }
}
